import React, { useState, useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
// ⬇️ use the new admin hook filename
import useAdminUserProfiles from '../../../api/panel/userProfiles';
import ViewUserProfiles from '../../../components/admin/user-profiles/ViewUserProfiles';
import { Spinner, Pagination, Message, Search } from '../../../components';
import { useTranslation } from 'react-i18next';

const UserProfiles = () => {
    const [page, setPage] = useState(1);
    const [q, setQ] = useState('');
    const { t } = useTranslation();

    const { getUserProfiles, generateMissingProfiles } = useAdminUserProfiles({
        page,
        q,
    });

    const { data, isLoading, isError, error, refetch } = getUserProfiles;
    const { mutateAsync: generateMissing, isLoading: isGenerating } =
        generateMissingProfiles;

    useEffect(() => {
        // react-query already refetches when page/q change because of the key
        // but if you want to force:
        if (q.trim() || page) {
            refetch();
        }
    }, [page, q, refetch]);

    const searchHandler = (e) => {
        e.preventDefault();
        setPage(1);
        refetch();
    };

    const handleGenerateMissing = async () => {
        try {
            await generateMissing();
            // list is invalidated inside the mutation, so no manual refetch needed
        } catch {
            // error messages handled by AdminMessageContext
        }
    };

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>User Profiles</title>
                    <meta property="og:title" content="User Profiles" key="title" />
                </Helmet>
            </HelmetProvider>

            <div className="view-list-top-bar">
                <h3 className="fw-light text-muted text-center mb-3">
                    {t('UserProfiles List')}{' '}
                    <sup className="fs-6">[{data && data.total}]</sup>
                </h3>

                <div className="d-flex align-items-center justify-content-between mb-2 full-width-pagination">
                    <Pagination data={data} setPage={setPage} />
                </div>

                <div className="col-auto full-search">
                    <Search
                        placeholder={t('Search by Name')}
                        setQ={setQ}
                        q={q}
                        searchHandler={searchHandler}
                    />
                </div>
            </div>

            {isLoading ? (
                <Spinner />
            ) : isError ? (
                <Message variant="danger">{error?.message || String(error)}</Message>
            ) : (
                <ViewUserProfiles
                    data={data}
                    onGenerateMissing={handleGenerateMissing}
                    isGenerating={isGenerating}
                />
            )}

            <div className="pagination-bottom-block">
                <Pagination data={data} setPage={setPage} />
            </div>
        </>
    );
};

export default UserProfiles;
